/*  ========================================================================
    # Scripts - History Timeline
    ========================================================================  */

/**
 * Script that toggles an active class on history timeline list items
 * once more than half of their height is visible in the viewport.
 */
const HistoryTimeline = {
  cfg: {
    activeClass: 'is-active',
    threshold: 0.5
  },

  /**
   * Initialize the intersection observer for a single list.
   */
  initList(list) {
    const items = list.querySelectorAll('.s-history__list-item-wrapper');
    if (!items.length) return;

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add(this.cfg.activeClass);
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: this.cfg.threshold }
    );

    items.forEach(item => observer.observe(item));
  },

  /**
   * Initialize all history timeline lists.
   */
  init() {
    document.querySelectorAll('.s-history__list').forEach(list => {
      this.initList(list);
    });
  }
};

export default HistoryTimeline;
